import SearchBar from "../Product/SearchBar";
import LanguageDropDown from "./LanguageDropDown";
import Notifications from "./Notifications";
import UserDopdown from "../Product/UserDropdown";
import { useUserRole } from "@/hooks/useUserRole";

function HeaderInfo() {
  const { isAdmin, isBranchAdmin,isCashier } = useUserRole()
  const shouldSeeSearchbar = isAdmin || isBranchAdmin || isCashier
  return (
    <div className="col-start-2 col-end-13 flex h-full w-fit items-center justify-between gap-x-2 text-black md:w-full lg:pe-7">
      
      <div className="relative ml-1 mt-1 hidden w-full md:flex md:max-w-xs min-[850px]:max-w-xl">
        {shouldSeeSearchbar &&<SearchBar />}
      </div>

      <div className="flex items-center">
        <Notifications />
        <LanguageDropDown />
        <UserDopdown />
      </div>
    </div>
  );
}

export default HeaderInfo;
